module.exports = __webpack_public_path__ + "img/manda_024.780d29a1.png";